import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { DrawingPreviewNavigationService } from './drawing-preview-navigation.service';

@Component({
  selector: 'hb-drawing-preview-navigation',
  templateUrl: './drawing-preview-navigation.component.html',
  styleUrls: ['./drawing-preview-navigation.component.scss'],
})
export class DrawingPreviewNavigationComponent implements OnInit {
  private _svgElement: SVGSVGElement;

  get svgElement(): SVGSVGElement {
    return this._svgElement;
  }

  @Input() set svgElement(value: SVGSVGElement) {
    this._svgElement = value;
    this.svgViewBoxService.setSvg(this.svgElement);
  }

  @Output() zoom = new EventEmitter<any>(null);

  constructor(private svgViewBoxService: DrawingPreviewNavigationService) { }

  ngOnInit() {
  }

  zoomIn() {
    this.svgViewBoxService.zoomIn();
    this.zoom.emit();
  }

  zoomOut() {
    this.svgViewBoxService.zoomOut();
    this.zoom.emit();
  }

  moveUp() {
    this.svgViewBoxService.moveUp();
  }

  moveDown() {
    this.svgViewBoxService.moveDown();
  }

  moveLeft() {
    this.svgViewBoxService.moveLeft();
  }

  moveRight() {
    this.svgViewBoxService.moveRight();
  }
}
